import { render, staticRenderFns } from "./QuestionBase.vue?vue&type=template&id=464b8c12&scoped=true&"
import script from "./QuestionBase.vue?vue&type=script&lang=js&"
export * from "./QuestionBase.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBase.vue?vue&type=style&index=0&id=464b8c12&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464b8c12",
  null
  
)

export default component.exports